<template>
  <div>
    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
      <div v-if="$page.props.jetstream.canUpdateProfileInformation">
        <update-profile-information-form :user="$page.props.user" />

        <jet-section-border />
      </div>

      <div v-if="$page.props.jetstream.canUpdatePassword">
        <update-password-form class="mt-10 sm:mt-0" />

        <jet-section-border />
      </div>

      <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
        <two-factor-authentication-form class="mt-10 sm:mt-0" />

        <jet-section-border />
      </div>

      <logout-other-browser-sessions-form
        :sessions="sessions"
        class="mt-10 sm:mt-0"
      />

      <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
        <jet-section-border />

        <delete-user-form class="mt-10 sm:mt-0" />
      </template>
    </div>
  </div>
</template>

<script>
import DeleteUserForm from './DeleteUserForm.vue';
import JetSectionBorder from '../../Jetstream/SectionBorder.vue';
import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm.vue';
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm.vue';
import UpdatePasswordForm from './UpdatePasswordForm.vue';
import UpdateProfileInformationForm from './UpdateProfileInformationForm.vue';

export default {

  components: {
    DeleteUserForm,
    JetSectionBorder,
    LogoutOtherBrowserSessionsForm,
    TwoFactorAuthenticationForm,
    UpdatePasswordForm,
    UpdateProfileInformationForm,
  },
  props: ['sessions'],
};
</script>
